import { render } from "./EnbPedido.vue?vue&type=template&id=4bd567e1&scoped=true"
import script from "./EnbPedido.vue?vue&type=script&lang=js"
export * from "./EnbPedido.vue?vue&type=script&lang=js"

import "./EnbPedido.vue?vue&type=style&index=0&id=4bd567e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd567e1"]])

export default __exports__